module.exports = __webpack_public_path__ + "static/media/everyday_digital.d304dcb9.webp";